// Port of api/fuel/app/classes/controller/api/monty/tags/delete.php
import DB from 'offline/db'
import {
	loadOwnedTag,
	persist,
	sessionUserId,
	tagToArray,
	touchAttachmentCounts,
	unauthorised
} from './shared'

export default function(params) {
	var userId = sessionUserId(params)
	var tag = false
	var payload = false
	var familyId = 0

	if (!userId) {
		return unauthorised()
	}

	tag = loadOwnedTag(userId, params.tag)
	if (!tag) {
		return unauthorised()
	}

	payload = tagToArray(tag)
	familyId = parseInt(tag.family_id, 10) || 0

	DB.run('DELETE FROM tag_attach WHERE tag_id = ?', [parseInt(tag.tag_id, 10) || 0])
	DB.run('DELETE FROM tag WHERE tag_id = ?', [parseInt(tag.tag_id, 10) || 0])
	touchAttachmentCounts([], familyId ? [familyId] : [])

	return persist(payload)
}
